export default "__VITE_ASSET__51DD4BaQ__"